import React, { useLayoutEffect, useRef, useState } from "react"
import { Asset, Link } from "../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import { EdgeTop2, ProductQuality, ProductFreeze, ProductRipe, ProductYear } from "../icons"
import StructuredText from "../structured-text/custom-structured-text-renderer"
import AnimationButton from "../structured-text/blocks/animation-button"

const Cta = ({ cta, brand, categories, colorBg, colorText }) => {
  const edgeTopRef = useRef()
  const [edgeHeight, setEdgeHeight] = useState()

  useLayoutEffect(() => {
    const handleOffsetHeight = () => {
      setEdgeHeight(edgeTopRef?.current?.offsetHeight)
    }

    handleOffsetHeight()

    window.addEventListener("resize", () => handleOffsetHeight())

    return () => {
      window.removeEventListener("resize", () => handleOffsetHeight())
    }
  }, [])

  return (
    <section
      className={`product__cta ${cta.brand ? cta.brand : brand}`}>
      {cta.brand === "woods" && (
        <div ref={edgeTopRef} className="product__cta--edge">
          <EdgeTop2 color="#FFFFFF" />
        </div>
      )}
      <div className="product__cta--inner">
        <div className="product__cta--media">
          {cta.image && <Asset asset={cta.image} />}
          {cta.sunnysideSecondImage && <Asset asset={cta.sunnysideSecondImage} />}
        </div>

        <div className="product__cta--content">
          {cta.title && <h3>{parse(cta.title)}</h3>}

          {brand === 'sunnyside' && <p>Sunnyside frozen fruit and vegetable products capture peak flavour, colour and nutrition. Individually quick frozen for freshness, they offer year-round consistency, convenience and premium quality with no prep.</p> }

          {brand === "sunnyside" && (
            <div className="sunnyside-quality__items">
              <div className="sunnyside-quality__item">
                <div className="sunnyside-quality__item-content">
                  <p>Highest<br />Quality</p>
                </div>
                <div className="sunnyside-quality__item-icon">
                  <ProductQuality />
                </div>
              </div>
              <div className="sunnyside-quality__item">
                <div className="sunnyside-quality__item-content">
                  <p>Peak<br />Ripeness</p>
                </div>
                <div className="sunnyside-quality__item-icon">
                  <ProductRipe />
                </div>
              </div>
              <div className="sunnyside-quality__item">
                <div className="sunnyside-quality__item-content">
                  <p>Quick<br />Freeze</p>
                </div>
                <div className="sunnyside-quality__item-icon">
                  <ProductFreeze />
                </div>
              </div>
              <div className="sunnyside-quality__item">
                <div className="sunnyside-quality__item-content">
                  <p>Year-Round<br />Availability</p>
                </div>
                <div className="sunnyside-quality__item-icon">
                  <ProductYear />
                </div>
              </div>
            </div>
          )}

          {cta.buttons?.length > 0 &&
            cta.buttons.map((el, i) => (
              <AnimationButton
                className="btn btn--animation"
                key={i}
                to={
                  el.link[0].externalLink
                    ? el.link[0].externalLink
                    : el.link[0].internalLink?.permalink
                }
              >
                {el.title}
              </AnimationButton>
            ))}
        </div>
      </div>
    </section>
  )
}

export default Cta
